import { render } from "./Bundle.vue?vue&type=template&id=625bbd40&lang=pug"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"

import "./Bundle.vue?vue&type=style&index=0&id=625bbd40&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__